<template>
  <div class="profile-page">

    <div class="profile-picture">
      <img v-if="user" :src="`https://robohash.org/${user.email}`">
    </div>
    <p v-if="user" class="username">{{ user.email }}</p>
    <small class="joined" v-if="joinedText">{{ joinedText }}</small>

    <div class="profile-stats">
      <div>
        <p>10</p>
        <p>Dishes</p>
      </div>
      <div>
        <p>2</p>
        <p>Milestones </p>
      </div>
      <div>
        <p>23</p>
        <p>Logs</p>
      </div>
    </div>

    <div class="profile-options">
      <button class="button primary">Change Password</button>
    </div>

  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, computed } from 'vue'
import { getAuth, updatePassword, onAuthStateChanged, User } from 'firebase/auth'
import { formatDistanceToNow } from 'date-fns'

const auth = getAuth()
const user = ref<User | null>(null)
const newPassword = ref('')
const message = ref('')
const error = ref('')
const loading = ref(false)

const joinedText = computed(() => {
  if (user.value?.metadata?.creationTime) {
    const createdAt = new Date(user.value.metadata.creationTime)
    return `Joined ${formatDistanceToNow(createdAt, { addSuffix: false })} ago`
  }
  return ''
})

onMounted(() => {
  onAuthStateChanged(auth, (currentUser) => {
    if (currentUser) {
      user.value = currentUser
    }
  })
})

const changePassword = async () => {
  message.value = ''
  error.value = ''

  if (auth.currentUser) {
    loading.value = true
    try {
      await updatePassword(auth.currentUser, newPassword.value)
      message.value = 'Password changed successfully.'
      newPassword.value = ''
    } catch (err: any) {
      error.value = err.message
    } finally {
      loading.value = false
    }
  } else {
    error.value = 'User is not authenticated.'
  }
}

</script>

<style scoped>

.profile-picture {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-color: #e9e9e9;
  margin: 0 auto 20px;
}

.profile-picture > img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.username, .joined {
  text-align: center;
  width: 100%;
  display: block;
}

.joined {
  font-weight: 300;
  margin-top: var(--space-sm);
}

.profile-options {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: var(--space-lg);
}

.profile-options .button {
  width: 100%;
}

.profile-stats {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  margin-top: var(--space-lg);
}

.profile-stats > div {
  width: 33.33%;
}

.profile-stats p {
  text-align: center;
}

.profile-stats p:nth-of-type(2) {
  font-weight: 600;
}
</style>
